
export default "/assets/arrow-path-micro.e5ca7247.svg"